module.exports = __webpack_public_path__ + "static/media/profile.0308f194.svg";